export const categories = [
  { slug: "riman", name: "日漫", description: "日本漫画精选，热血、恋爱、冒险全收录" },
  { slug: "hanman", name: "韩漫", description: "韩国漫画大全，剧情向精品免费阅读" },
  { slug: "guoman", name: "国漫", description: "国产漫画崛起之作，支持原创漫画" },
  { slug: "wanjie", name: "完结", description: "已完结漫画一次性看完，追更无需等待" },
  { slug: "lianzai", name: "连载", description: "火热连载中，每周更新追更不停" },
];

export const comics = [
  {
    id: "1",
    title: "咒术回战",
    cover: "https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20manga%20cover%20style%20dynamic%20action%20scene%20with%20dark%20energy%20and%20intense%20character%20illustration%20on%20clean%20white%20background%2C%20Japanese%20manga%20art%20style%2C%20bold%20lines%2C%20dramatic%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    author: "芥见下下",
    category: "riman",
    status: "连载",
    updateTime: "2026-08-04",
    description: "少年与诅咒的激斗物语。高中生虎杖悠仁偶然吞食了宿傩的手指，从此被卷入诅咒的世界。为了收集散落的宿傩手指，他加入了东京都立咒术高等专门学校，与伙伴们共同对抗诅咒。",
    tags: ["热血", "战斗", "校园", "奇幻"],
    views: 1280000,
    rating: 9.5,
    chapters: [
      { id: "ch1", title: "第1话 两面宿傩", number: 1 },
      { id: "ch2", title: "第2话 秘密行刑", number: 2 },
      { id: "ch3", title: "第3话 为了自己", number: 3 },
      { id: "ch4", title: "第4话 咒术高专", number: 4 },
      { id: "ch5", title: "第5话 咒术师的战斗", number: 5 },
    ],
  },
  {
    id: "2",
    title: "我独自升级",
    cover: "https://readdy.ai/api/search-image?query=Solo%20Leveling%20Korean%20manhwa%20cover%20style%20dark%20fantasy%20hunter%20with%20glowing%20eyes%20and%20shadow%20army%2C%20dramatic%20lighting%2C%20clean%20white%20background%2C%20intense%20character%20pose%2C%20sharp%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    author: "CHUGONG",
    category: "hanman",
    status: "完结",
    updateTime: "2026-07-28",
    description: '在连接异次元的“门”突然出现的世界，被称为“猎人”的觉醒者们对抗着来自门内的怪物。E级猎人成振宇在一次几乎团灭的突袭中奇迹生还，醒来后发现自己获得了可以无限成长的能力——「系统」。',
    tags: ["奇幻", "战斗", "升级", "暗影"],
    views: 2560000,
    rating: 9.8,
    chapters: [
      { id: "ch1", title: "第1话 最弱的猎人", number: 1 },
      { id: "ch2", title: "第2话 系统激活", number: 2 },
      { id: "ch3", title: "第3话 每日任务", number: 3 },
      { id: "ch4", title: "第4话 初次升级", number: 4 },
      { id: "ch5", title: "第5话 地下城突袭", number: 5 },
    ],
  },
  {
    id: "3",
    title: "一人之下",
    cover: "https://readdy.ai/api/search-image?query=The%20Outcast%20Chinese%20manhua%20cover%20style%20traditional%20Taoist%20elements%20with%20modern%20urban%20setting%2C%20mystical%20energy%20flowing%20around%20characters%2C%20clean%20white%20background%2C%20Chinese%20ink%20painting%20influence&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    author: "米二",
    category: "guoman",
    status: "连载",
    updateTime: "2026-08-02",
    description: "普通大学生张楚岚因爷爷的坟墓被盗而回到家乡，却意外卷入了异人世界的纷争。在这个普通人所不知道的世界里，拥有特殊能力的异人们相互争斗，而张楚岚也一步步揭开自己身世的秘密。",
    tags: ["奇幻", "冒险", "道家", "现代"],
    views: 1890000,
    rating: 9.3,
    chapters: [
      { id: "ch1", title: "第1话 爷爷的坟墓", number: 1 },
      { id: "ch2", title: "第2话 异人世界", number: 2 },
      { id: "ch3", title: "第3话 冯宝宝", number: 3 },
      { id: "ch4", title: "第4话 哪都通", number: 4 },
      { id: "ch5", title: "第5话 罗天大醮", number: 5 },
    ],
  },
  {
    id: "4",
    title: "鬼灭之刃",
    cover: "https://readdy.ai/api/search-image?query=Demon%20Slayer%20Kimetsu%20no%20Yaiba%20manga%20cover%20style%20swordsman%20with%20water%20breathing%20technique%20visual%20effect%2C%20traditional%20Japanese%20aesthetic%2C%20clean%20white%20background%2C%20elegant%20and%20dynamic%20illustration&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    author: "吾峠呼世晴",
    category: "riman",
    status: "完结",
    updateTime: "2026-06-15",
    description: "大正时代的日本。少年灶门炭治郎一家惨遭鬼的袭击，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹恢复人类之身，炭治郎踏上了成为鬼杀队剑士的道路，斩鬼之旅就此展开。",
    tags: ["热血", "战斗", "和风", "兄妹"],
    views: 3200000,
    rating: 9.7,
    chapters: [
      { id: "ch1", title: "第1话 残酷", number: 1 },
      { id: "ch2", title: "第2话 育手", number: 2 },
      { id: "ch3", title: "第3话 最终选拔", number: 3 },
      { id: "ch4", title: "第4话 第一任务", number: 4 },
      { id: "ch5", title: "第5话 浅草", number: 5 },
    ],
  },
  {
    id: "5",
    title: "全职猎人",
    cover: "https://readdy.ai/api/search-image?query=Hunter%20x%20Hunter%20manga%20cover%20style%20adventure%20theme%20with%20young%20hunter%20and%20mysterious%20creatures%2C%20vibrant%20colors%2C%20clean%20white%20background%2C%20classic%20Japanese%20manga%20aesthetic&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    author: "富坚义博",
    category: "riman",
    status: "连载",
    updateTime: "2026-08-03",
    description: "小杰为了寻找父亲金，决心成为猎人。在猎人考试中，他结识了奇犽、酷拉皮卡和雷欧力三位好友，一起踏上了充满未知与危险的冒险旅程。这是一个关于友情、勇气与成长的故事。",
    tags: ["冒险", "战斗", "友情", "念能力"],
    views: 2100000,
    rating: 9.6,
    chapters: [
      { id: "ch1", title: "第1话 出发之日", number: 1 },
      { id: "ch2", title: "第2话 暴风雨中", number: 2 },
      { id: "ch3", title: "第3话 最终试验", number: 3 },
      { id: "ch4", title: "第4话 奇犽的挑战", number: 4 },
      { id: "ch5", title: "第5话 天空竞技场", number: 5 },
    ],
  },
  {
    id: "6",
    title: "女神降临",
    cover: "https://readdy.ai/api/search-image?query=True%20Beauty%20Korean%20webtoon%20cover%20style%20beautiful%20girl%20with%20makeup%20transformation%20theme%2C%20soft%20romantic%20aesthetic%2C%20clean%20white%20background%2C%20modern%20fashion%20illustration%2C%20Korean%20manhwa%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    author: "Yaongyi",
    category: "hanman",
    status: "完结",
    updateTime: "2026-05-20",
    description: "因为长相平凡而被欺负的任朱静，通过化妆技巧彻底改变了外貌，成为了校园里的女神。然而她必须时刻隐藏自己素颜的秘密，同时周旋在两个性格迥异的男生之间，展开了一段关于美丽与真实的青春故事。",
    tags: ["恋爱", "校园", "化妆", "青春"],
    views: 1800000,
    rating: 9.2,
    chapters: [
      { id: "ch1", title: "第1话 化妆的力量", number: 1 },
      { id: "ch2", title: "第2话 新学校的开始", number: 2 },
      { id: "ch3", title: "第3话 两个男生", number: 3 },
      { id: "ch4", title: "第4话 秘密", number: 4 },
      { id: "ch5", title: "第5话 素颜危机", number: 5 },
    ],
  },
  {
    id: "7",
    title: "镖人",
    cover: "https://readdy.ai/api/search-image?query=Blades%20of%20the%20Guardians%20Chinese%20manhua%20cover%20style%20ancient%20Chinese%20warrior%20with%20sword%20in%20desert%20landscape%2C%20bold%20brushstroke%20style%2C%20clean%20white%20background%2C%20dynamic%20action%20pose%2C%20ink%20wash%20aesthetic&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    author: "许先哲",
    category: "guoman",
    status: "连载",
    updateTime: "2026-08-01",
    description: "隋末唐初，江湖动荡。镖客刀马带着年幼的小七行走于大漠与长安之间，接下各种危险的护送任务。在这乱世之中，他以一身武艺和侠义之心，书写着属于自己的传奇故事。",
    tags: ["武侠", "历史", "动作", "古风"],
    views: 1560000,
    rating: 9.4,
    chapters: [
      { id: "ch1", title: "第1话 大漠镖客", number: 1 },
      { id: "ch2", title: "第2话 长安城", number: 2 },
      { id: "ch3", title: "第3话 知世郎", number: 3 },
      { id: "ch4", title: "第4话 护送任务", number: 4 },
      { id: "ch5", title: "第5话 西域来客", number: 5 },
    ],
  },
  {
    id: "8",
    title: "间谍过家家",
    cover: "https://readdy.ai/api/search-image?query=Spy%20x%20Family%20manga%20cover%20style%20elegant%20spy%20family%20portrait%20with%20gentleman%20assassin%20and%20telepath%20child%2C%20warm%20tones%2C%20clean%20white%20background%2C%20charming%20and%20playful%20illustration&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    author: "远藤达哉",
    category: "riman",
    status: "连载",
    updateTime: "2026-08-04",
    description: '为了执行维护东西和平的机密任务，顶尖间谍“黄昏”需要组建一个临时家庭。他领养了能读心的女儿阿尼亚，与杀手约尔假结婚，组成了一个看似普通却各怀绝技的伪装家庭，笑料与感动并存。',
    tags: ["喜剧", "家庭", "间谍", "温馨"],
    views: 2980000,
    rating: 9.6,
    chapters: [
      { id: "ch1", title: "第1话 任务开始", number: 1 },
      { id: "ch2", title: "第2话 寻找女儿", number: 2 },
      { id: "ch3", title: "第3话 约尔", number: 3 },
      { id: "ch4", title: "第4话 入学面试", number: 4 },
      { id: "ch5", title: "第5话 家庭日常", number: 5 },
    ],
  },
  {
    id: "9",
    title: "看脸时代",
    cover: "https://readdy.ai/api/search-image?query=Lookism%20Korean%20webtoon%20cover%20style%20duality%20of%20handsome%20and%20overweight%20character%20split%20composition%2C%20dramatic%20contrast%2C%20clean%20white%20background%2C%20social%20commentary%20theme%2C%20modern%20manhwa%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    author: "朴泰俊",
    category: "hanman",
    status: "连载",
    updateTime: "2026-07-30",
    description: "因为肥胖和长相在学校备受欺负的朴亨锡，某天醒来发现自己拥有了另一副完美的身体。他可以在两副身体之间切换，白天是帅气的人生赢家，晚上则变回原来的自己。这部作品深刻探讨了外貌歧视与社会偏见。",
    tags: ["校园", "社会", "双面", "成长"],
    views: 2340000,
    rating: 9.1,
    chapters: [
      { id: "ch1", title: "第1话 另一个我", number: 1 },
      { id: "ch2", title: "第2话 新学校", number: 2 },
      { id: "ch3", title: "第3话 双重生活", number: 3 },
      { id: "ch4", title: "第4话 校园霸王", number: 4 },
      { id: "ch5", title: "第5话 真相", number: 5 },
    ],
  },
  {
    id: "10",
    title: "狐妖小红娘",
    cover: "https://readdy.ai/api/search-image?query=Fox%20Spirit%20Matchmaker%20Chinese%20manhua%20cover%20style%20beautiful%20fox%20spirit%20girl%20with%20traditional%20Chinese%20elements%2C%20ancient%20fantasy%20setting%2C%20clean%20white%20background%2C%20romantic%20and%20mystical%20atmosphere&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    author: "小新",
    category: "guoman",
    status: "连载",
    updateTime: "2026-08-03",
    description: "在人妖共存的世界中，涂山狐妖一族以红线仙的身份，帮助人与妖再续前世的缘分。涂山苏苏立志成为最优秀的红线仙，在一段段前世今生的故事中，她与道士白月初展开了一段奇妙的冒险。",
    tags: ["爱情", "奇幻", "转世", "古风"],
    views: 1670000,
    rating: 9.4,
    chapters: [
      { id: "ch1", title: "第1话 涂山苏苏", number: 1 },
      { id: "ch2", title: "第2话 白月初", number: 2 },
      { id: "ch3", title: "第3话 红线仙", number: 3 },
      { id: "ch4", title: "第4话 前世今生", number: 4 },
      { id: "ch5", title: "第5话 涂山红线", number: 5 },
    ],
  },
  {
    id: "11",
    title: "进击的巨人",
    cover: "https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20manga%20cover%20style%20colossal%20giant%20breaking%20through%20wall%20with%20soldiers%20in%20combat%20gear%2C%20apocalyptic%20atmosphere%2C%20clean%20white%20background%2C%20epic%20scale%2C%20dramatic%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    author: "谏山创",
    category: "riman",
    status: "完结",
    updateTime: "2026-03-10",
    description: "在巨人的威胁下，人类被迫生活在巨大的城墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬后，立誓要驱逐所有巨人。他加入调查兵团，逐渐揭开巨人和城墙背后隐藏的惊天秘密。",
    tags: ["战斗", "黑暗", "生存", "反转"],
    views: 4500000,
    rating: 9.9,
    chapters: [
      { id: "ch1", title: "第1话 致两千年后的你", number: 1 },
      { id: "ch2", title: "第2话 那一天", number: 2 },
      { id: "ch3", title: "第3话 散落之夜", number: 3 },
      { id: "ch4", title: "第4话 初阵", number: 4 },
      { id: "ch5", title: "第5话 刀刃", number: 5 },
    ],
  },
  {
    id: "12",
    title: "全知读者视角",
    cover: "https://readdy.ai/api/search-image?query=Omniscient%20Reader%20Viewpoint%20Korean%20webtoon%20cover%20style%20apocalyptic%20scenario%20with%20protagonist%20holding%20a%20book%20amidst%20chaos%2C%20constellation%20theme%2C%20clean%20white%20background%2C%20dramatic%20lighting&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    author: "sing N song",
    category: "hanman",
    status: "连载",
    updateTime: "2026-08-02",
    description: "平凡上班族金独子，是一本冷门网络小说《在灭亡世界生存的三种方法》的唯一读者。当小说中的末日场景突然在现实中上演，他凭借十年的阅读经验，在这个被故事吞噬的世界中展开了自己的生存之旅。",
    tags: ["末世", "生存", "星座", "策略"],
    views: 2100000,
    rating: 9.5,
    chapters: [
      { id: "ch1", title: "第1话 唯一的读者", number: 1 },
      { id: "ch2", title: "第2话 末日降临", number: 2 },
      { id: "ch3", title: "第3话 第一幕", number: 3 },
      { id: "ch4", title: "第4话 星座的注视", number: 4 },
      { id: "ch5", title: "第5话 同伴", number: 5 },
    ],
  },
];

export const featuredComics = comics.slice(0, 6);

export const latestUpdates = comics.slice().sort(() => Math.random() - 0.5).slice(0, 8);

export const hotRankings = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

export const faqData = [
  {
    question: "哔咔动漫需要付费吗？",
    answer: "哔咔动漫平台上的所有漫画资源均为免费阅读，无需任何付费。我们致力于为漫画爱好者提供无门槛的阅读体验，日漫、韩漫、国漫全覆盖，没有任何隐藏收费项目。",
  },
  {
    question: "如何找到我想看的漫画？",
    answer: "您可以通过首页的分类导航（日漫、韩漫、国漫、完结、连载）快速浏览感兴趣的品类，也可以使用搜索功能直接查找漫画名称。我们还提供了热门推荐和最新更新板块，帮助您发现优质作品。",
  },
  {
    question: "哔咔漫画支持什么阅读方式？",
    answer: "哔咔动漫提供流畅的下拉式在线阅读体验，无需翻页，手指向下滑动即可连续阅读所有章节。同时也支持章节跳转和目录导航，方便您快速定位到想看的章节。",
  },
  {
    question: "更新频率是怎样的？",
    answer: "连载中的漫画会跟随原版同步更新。日漫通常在每周特定日期更新，韩漫多为每周更新一到两次，国漫更新频率视具体作品而定。您可以在漫画详情页查看最新的更新时间。",
  },
  {
    question: "可以在手机上使用哔咔动漫吗？",
    answer: "哔咔动漫网站完美适配手机、平板和电脑等各类设备。无论是iOS还是Android系统，您都可以通过浏览器直接访问，享受流畅的下拉式漫画阅读体验，无需下载任何APP。",
  },
  {
    question: "找不到想看的漫画怎么办？",
    answer: "如果您想看的漫画暂时不在我们的平台上，欢迎通过「关于我们」页面的联系方式向我们反馈。我们的内容团队会认真对待每一份推荐请求，持续扩充漫画资源库。",
  },
];

export const testimonials = [
  {
    name: "小陈同学",
    avatar: "",
    rating: 5,
    content: "哔咔动漫真的是我的精神食粮！日漫资源太全了，咒术回战、鬼灭之刃每周都在追。关键是全免费，没有任何广告打扰阅读体验，太良心了！",
  },
  {
    name: "韩漫爱好者阿琳",
    avatar: "",
    rating: 5,
    content: "作为一个重度韩漫控，哔咔漫画免费观看的韩漫库真的惊到我了！我独自升级、女神降临这些热门作品都有，阅读体验流畅到不行，下拉式阅读太舒服了。",
  },
  {
    name: "漫画达人老王",
    avatar: "",
    rating: 5,
    content: "用了哔咔快一年了，从没遇到收费门坎。更新速度快，每天都有新内容。推荐给了身边所有爱看漫画的朋友，一致好评！免费漫画大全就选哔咔！",
  },
  {
    name: "大学生小宇",
    avatar: "",
    rating: 4,
    content: "国漫资源也很丰富，镖人、一人之下、狐妖小红娘都是宝藏作品。支持国产原创漫画，希望哔咔动漫越做越好，引进更多优质国漫！",
  },
];

export const aboutInfo = {
  brandName: "哔咔动漫",
  slogan: "哔咔动漫免费全集 | 哔咔漫画免费观看下拉式在线阅读 - 日漫韩漫全免费",
  description: "哔咔动漫是一个致力于为漫画爱好者提供免费阅读体验的在线平台。我们聚合了海量日漫、韩漫、国漫资源，所有内容完全免费，无需付费订阅。平台采用先进的下拉式阅读技术，为用户带来流畅沉浸式的漫画阅读体验。",
  mission: "让每一个漫画爱好者都能自由地享受阅读的乐趣，打破付费壁垒，打造最全面的免费漫画在线阅读平台。",
  establishYear: "2019",
  contactEmail: "contact@bikadongman.com",
  contactWechat: "bikadongman",
  contactQQ: "1234567890",
};